import { render } from "./ProjectList.vue?vue&type=template&id=1e3ddabb&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=1e3ddabb&lang=scss&scoped=true"

import exportComponent from "/Users/benjamin_nalo/Ben/portfolio-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3ddabb"]])

export default __exports__